import React, { Component } from "react";
import styles from "../orders/OrdersSearch.module.scss";
import stylesNew from "./DealerSearch.module.scss";
import DealerGroupingClient from "../../../../shared/clients/DealerGroupingClient";
import commonStyles from "./../../../../styles/common/CommonStyles.module.scss";
import { withTranslation } from "react-i18next";
import DealerSearchResults from "./DealerSearchResults";
import SubNav from "../../../../shared/subnav/SubNav";
import { AVAILABLE_MARKETS } from "../orders/AvailableMarkets";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../../utils/EmpUtil";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import UpperCaseText from "../../../../utils/UpperCaseText";

class DealerSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealers: {},
      dealerId: "",
      invalidDealerIdError: false,
      dealerNotActiveError: false,
      dealerNotFoundError: false,
      selectedMarket: undefined,
      dealerSearchMarketSelect: true,
    };
    this.showMarketDropDown =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "orderSearchMarketDropDown:view"
      );
  }

  componentDidMount() {
    this.setState({
      selectedMarket: this.props.selectedMarket,
      listOfMarkets: this.props.groups,
    });

    let defaultUserMarket = this.props.selectedMarket?.toUpperCase();

    if (!AVAILABLE_MARKETS.hasOwnProperty(defaultUserMarket)) {
      if (defaultUserMarket === "SWE") {
        defaultUserMarket = "NOR";
      } else {
        defaultUserMarket = "GBR";
      }
    }
    this.setState({ selectedMarket: defaultUserMarket });
  }

  onMarketChange = (event) => {
    const market = event.target.value;

    this.setState(
      {
        selectedMarket: market,
        listOfMarkets: this.props.groups,
        dealers: {},
        searchQuery: "",
        invalidDealerIdError: false,
        dealerNotFoundError: false,
        dealerNotActiveError: false,
        dealerId: "",
      },
      () => {
        if (this.props.isNsc) this.props.updateCurrentMarket(market);
      }
    );
  };

  handleInputChange = (event) => {
    const searchText = NOTNULL_OR_NOTUNDEFINED(event.target.value)
      ? event.target.value.trim()
      : "";

    this.setState({
      ...this.state,
      dealerId: UpperCaseText(searchText),
      invalidDealerIdError: false,
      dealerNotFoundError: false,
      dealerNotActiveError: false,
    });
  };

  handleSearch = (e) => {
    this.props.hideOrShow(true);
    e.preventDefault();
    const searchTerm = this.state.dealerId.toUpperCase();

    if (this.invalidDealerId(searchTerm)) {
      this.setState({
        dealers: {},
        invalidDealerIdError: true,
      });
      this.props.hideOrShow(false);
    } else {
      this.getDealerGroup();
    }
  };

  getDealerGroup = () => {
    DealerGroupingClient.dealerSearch(
      this.state.selectedMarket,
      this.props.user,
      this.state.dealerId
    )
      .then((data) => {
        const dealers = data.dealerGroupings.filter(
          (dealer) => dealer.completeDealerId === this.state.dealerId
        );
        if (Array.isArray(dealers) && dealers.length > 0) {
          this.setState({
            ...this.state,
            dealers: dealers,
            showResults: true,
            dealerNotFoundError: false,
            dealerNotActiveError: false,
            isValidDealerId: true,
          });
        } else {
          this.setState({
            dealers: {},
            isValidDealerId: false,
            dealerNotActiveError: data.dealerNotActiveError,
            dealerNotFoundError: true,
          });
        }
      })
      .catch(() => {
        this.setState({
          dealers: {},
          isValidDealerId: false,
          dealerNotFoundError: true,
        });
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  changeMarket = (e) => {
    this.setState(
      {
        selectedMarket: e.target.value,
        dealers: {},
        searchQuery: "",
        loaded: false,
        invalidDealerIdError: false,
        dealerNotFoundError: false,
        dealerNotActiveError: false,
        dealerId: "",
      },
      () => {
        if (this.props.isNsc) this.props.updateCurrentMarket(e.target.value);
      }
    );
  };

  validateDealerId = (e) => {
    if (e.target.value) {
      const searchTerm = e.target.value.toUpperCase();
      if (this.invalidDealerId(searchTerm)) {
        this.setState({
          dealers: {},
          invalidDealerIdError: true,
        });
      }
    }
  };

  invalidDealerId = (searchTerm) => {
    //Basic validation
    return searchTerm.length < 4;
  };

  render() {
    return (
      <div>
        <section className="pageWrapper">
          <BackToButton
            backToUrl={this.props.isCrc ? "/" : "/search"}
            display={this.props.t("SearchWrapper.backToSearch")}
          />

          <SubNav
            {...this.props}
            dashboard={false}
            showCustomDropdown={this.props.user.permissions.rolePermissions.hasOwnProperty(
              "orderSearchCountryDropDown:view"
            )}
            value={this.state.selectedMarket}
            dropDownValues={AVAILABLE_MARKETS}
            onChange={this.changeMarket}
            title={this.props.t("fieldView.title")}
            showCustomMarketDropdown={this.showMarketDropDown}
            listOfMarkets={this.state.listOfMarkets}
            updateMarket={this.onMarketChange}
          />

          <div className={styles.bottomPadding}>
            <div className={styles.indent}>
              <p className={styles.dealerSearchSubHeader}>
                {this.props.t("fieldView.subheader")}
                {this.state.selectedMarket}
                {this.props.t("fieldView.subheader1")}
              </p>
              <div className={styles.searchWrapper}>
                <form
                  className={styles.form}
                  id="valuationForm"
                  onSubmit={this.handleSearch}
                >
                  <input
                    placeholder={`${this.state.selectedMarket}${this.props.t(
                      "fieldView.placeHolder"
                    )}${this.state.selectedMarket}${this.props.t(
                      "fieldView.placeHolder1"
                    )}`}
                    name="dealerSearch"
                    id="dealerSearch"
                    data-testid="dealerSearch"
                    value={this.state.dealerId}
                    onChange={this.handleInputChange}
                    className={`${
                      this.state.dealerNotFoundError ||
                      this.state.invalidDealerIdError ||
                      this.state.dealerNotActiveError
                        ? `${stylesNew.errorInput} ${stylesNew.inputField}`
                        : `${stylesNew.inputField}`
                    }`}
                    onKeyUp={this.validateDealerId}
                    required
                  />

                  <button
                    className={commonStyles.actionBtn}
                    type="submit"
                    id="searchBtn"
                    data-testid="searchBtn"
                  >
                    <div> {this.props.t("fieldView.search")} </div>
                  </button>
                </form>
              </div>
            </div>
            {this.state.invalidDealerIdError && (
              <div className={stylesNew.error}>
                {this.props.t("fieldView.codeError")}
              </div>
            )}
            {(this.state.dealerNotFoundError ||
              this.state.dealerNotActiveError) && (
              <div className={stylesNew.errorContainer}>
                <div className={stylesNew.error}>
                  {this.state.dealerNotActiveError ? (
                    <div>{this.props.t("fieldView.dealerNotActiveError")}</div>
                  ) : (
                    <>
                      <div>
                        {this.props.t("fieldView.dealerNotFoundError1")}
                      </div>
                      <div>
                        {this.props.t("fieldView.dealerNotFoundError2")}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {Object.keys(this.state.dealers).length !== 0 && (
              <DealerSearchResults
                {...this.props}
                dealers={this.state.dealers}
                selectedMarket={this.state.selectedMarket}
              />
            )}
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation("emp")(DealerSearch);
